export const Role = {
    Admin: "ADMIN",
    B24EmployeeRole: "B24_EMPLOYEE",
    AppUserRole: "APP_USER"
}

